import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function ExternalLinkIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_6815_16042)">
          <path
            d="M6.28125 9.57687L15.0312 0.96875"
            stroke={theme.palette.main.professional_blue}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.0312 5.88812V0.96875H10.0312"
            stroke={theme.palette.main.professional_blue}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.07812 4.09375H1.51562C1.37058 4.09375 1.23148 4.15137 1.12893 4.25393C1.02637 4.35648 0.96875 4.49558 0.96875 4.64062V14.4844C0.96875 14.6294 1.02637 14.7685 1.12893 14.8711C1.23148 14.9736 1.37058 15.0312 1.51562 15.0312H11.3594C11.5044 15.0313 11.6435 14.9736 11.7461 14.8711C11.8486 14.7685 11.9062 14.6294 11.9062 14.4844V7.92188"
            stroke={theme.palette.main.professional_blue}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_6815_16042">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
